<template>
  <div dir="rtl">
    <div v-if="applicant_data" class="is-flex is-justify-content-space-between">
      <div class="applicant_info_container" :class="{ applicant_info_container_with_pdf: show_pdf }">
        <div class="is-flex is-align-items-center">
          <start-vetting v-if="applicant_data && !isVetted" :payload="{ ...applicant_data, resource: { applicant: applicant_data } }">
          </start-vetting>
          <div class="horizontal_space"></div>
          <a v-if="referral_link" @click="copyAffiliateText" class="button is-outlined is-info">Copy Affiliate Text</a>
          <div class="horizontal_space"></div>
          <router-link :to="{ name: 'admin-applicants', query: { show_id: applicant_data.resource_id } }" class="blue_text"><u><b>GO TO APPLICANT</b></u></router-link>
          <button v-if="applicant_data && isVetted" @click="openNewVettingModal" class="mx-3 button is-info">Vetting Advanced</button>
          <div class="is-flex-grow-1" style="display: box" @click="applicantAnswered">
            <img class="operation_icon" style="float: left;" width="25" src="/applicant_answered.svg" />
          </div>
        </div>
        <p dir="ltr"><b>APPLICANT ID: </b>{{applicant_data.resource_id}}</p>
        <div class="is-flex is-align-items-center is-justify-content-space-between">
          <div class="is-flex is-align-items-center is-justify-content-flex-end">
            <img @click="openWhatsappModal" src="/whatsapp.svg" class="btn height_30px" width="30px">
            <div class="horizontal_space"></div>
            <img @click="openFilesModal" src="/files_icon.png" class="btn height_30px" width="30px">
            <div class="horizontal_space"></div>
            <img @click="openProfileModal" src="/profile_icon.svg" class="btn height_30px" width="30px">
            <div class="horizontal_space"></div>
            <a @click="openSkillsModal" class="button is-outlined is-info">Skills</a>
            <div class="horizontal_space"></div>
            <a v-if="show_download_cv" @click="downloadCv" class="button is-outlined">Download CV</a>
            <div class="horizontal_space"></div>
            <IsWatch :payload="{ resource_id: applicant_data.resource_id, resource: { applicant: applicant_data } }" />
            <div class="horizontal_space"></div>
            <IsStar :payload="{ resource_id: applicant_data.resource_id, resource: { applicant: applicant_data } }" />
            <div class="horizontal_space"></div>
            <AlertButton
              class="btn height_30px width_30px"
              :payload="applicant_data"
              :additional_data="{ resource_type: 'Applicant' }"
            />
            <div class="horizontal_space"></div>
            <CompanySuitcase :payload="applicant_data" imageStyle="image-style" />
            <div class="horizontal_space"></div>
            <IsFreeze :payload="applicant_data" />
          </div>
          <div class="is-flex is-align-items-center is-justify-content-flex-start">
            <ghana-flag :payload="applicant_data" :additional_data="{ resource_type: 'Applicant' }" :eager_load="true"></ghana-flag>
          </div>
        </div>
        <div class="text_align_left" dir="ltr" style="float: left;">
          <IsDiscrete :applicantId="applicant_data.resource_id" v-model="is_discrete_question" />
          <AttributeDisplay
            :value="applicant_data.certification_date"
            :displayValue="seniorityYears.toString()"
            :data="{ ...applicant_data, seniority: seniorityYears }"
            componentName="CrudCertificationDateSeniority"
            title="Seniority"
            requestName="updateApplicant"
            requestValue="certification_date"
            type="radio-group"
            :options="certificationDateOptions || []"
            :classTitle="applicant_data.certification_date ? 'is-6' : 'red_text is-6'"
            classValue="is-4"
            :beforeAction="certificationDateUpdate"
          />
          <question-editor v-if="approve_email_question"
                           :payload="{ question: approve_email_question, resource_type: 'Applicant', resource_id: applicant_data.resource_id }">
          </question-editor>
          <div v-if="proactive_promotion_question" class="is-flex is-align-items-center">
            <question-editor :payload="{ question: proactive_promotion_question, resource_type: 'Applicant', resource_id: applicant_data.resource_id }">
            </question-editor>
            &nbsp;<b>(שליחה חופשית)</b>
          </div>
          <div class="mt-5 is-flex is-align-items-center">
            <DateTime class="max-width-190px mx-2" @input="pickDate" :date="freezed_until" :show_time="false" />
            <label class="rtl">freezed_until: </label>
          </div>
          <div class="mt-5 ">
            <button class="button is-info" @click="createElevenMonthAlert">create 11 months alert</button>
          </div>
        </div>
        <div class="is-flex is-justify-content-center is-align-items-center">
          <button class="button is-success is-small ml-4" @click="sendFreeText">Send WA</button>
          <p>
            <b>Phone Number: </b>{{ applicant_data.phone_number }}
          </p>
        </div>
        <div>
          <question-editor v-if="job_title"
                           :payload="{ question: job_title, resource_type: 'Applicant', resource_id: applicant_data.resource_id }">
          </question-editor>
        </div>
        <div>
          <FreeSubmission
            :applicantId="applicant_data.resource_id"
            v-model="free_submission"
            :approvedAt="free_submission_approved_at"
            @update:approvedAt="free_submission_approved_at = $event"
          />
        </div>
        <div>
          <location-editor :payload="{ location, resource_type: 'Applicant', resource_id: applicant_data.resource_id }"></location-editor>
        </div>
        <div>
          <last-working-places :history_companies="history_companies" :applicant="applicant_data"></last-working-places>
        </div>
        <div class="vertical_space"></div>
        <div class="vertical_space"></div>
        <div class="mb-5">
          <applicant-educations :applicant="applicant_data" :educations="educations"></applicant-educations>
        </div>
        <ApplicantJobTitles dir="ltr" v-if="applicant_data" :applicant="applicant_data" />
        <Abstract :applicantId="applicant_data.resource_id" v-model="applicant_data.abstract" :submitableButton="true" />
        <div>
          <resource-languages resource_type="Applicant" :resource_id="applicant_data.resource_id" :languages="languages"></resource-languages>
        </div>
        <message-form :payload="{ resource_data: applicant_data, additional_data: { endpoint: '/users', headers: 'admin_headers', resource_type: 'Applicant' }, internal_submit_button: true }">
        </message-form>
        <div class="vertical_space"></div>
        <SkillsForm v-model="tags" :payload="{ data: applicant_data }" :internal_submit_button="true"></SkillsForm>

        <AttributeDisplay
          :value="applicant_data.salary_expectations_comment"
          :data="applicant_data"
          title="Salary Expectations"
          requestName="updateApplicant"
          requestValue="salary_expectations_comment"
        />

        <AttributeDisplay
          :value="applicant_data.preferred_work_region"
          :data="applicant_data"
          title="Preferred Work Region"
          requestName="updateApplicant"
          requestValue="preferred_work_region"
        />

        <resource-text-editor :payload="{ text_data: texts.job_description, designator: 'job_description', resource_type: 'Applicant', resource_id: applicant_data.resource_id }">
        </resource-text-editor>

        <p>
          <b>Owner: </b>{{ applicant_data.owner }}
        </p>
        <resource-text-editor :payload="{ text_data: texts.referral_text, designator: 'referral_text', resource_type: 'Applicant', resource_id: applicant_data.resource_id }">
        </resource-text-editor>
        <p>
          <b>Last Login: </b>{{ time_helper.makeTimeReadable(applicant_data.last_login) }}
        </p>
        <p>
          <b>Email: </b>{{ applicant_data.email }}
        </p>
        <div v-for="question in questions" :key="question.designator">
          <question-editor :payload="{ question, resource_type: 'Applicant', resource_id: applicant_data.resource_id }">
         </question-editor>
          <question-editor v-if="question.designator == 'seniority'"
                           :payload="{ question: skip_seniority_filter_question, resource_type: 'Applicant', resource_id: applicant_data.resource_id }">
          </question-editor>
        </div>
        <div v-if="Object.keys(skills_by_category).length > 0">
          <p><b><u>סקילס:</u></b></p>
          <div :key="category" v-for="(skill, category) in skills_by_category">
            <div>
              <span
                ><b>{{ category }}: </b></span
              >
              <span :key="skill.id" v-for="skill in skills_by_category[category]"
                >{{ skill.skill.name }} | </span
              >
            </div>
          </div>
        </div>
        <div class="mt-4">
          <p><b>internal_notes</b></p>
          <internal-notes :payload="applicant_data" :is_modal="false"></internal-notes>
        </div>
        <div>
          <button class="button is-info mt-5 mb-4 ml-3" @click="getRawTextOfApplicant">Get Raw Text</button>
          <button class="button is-info mt-5 mb-4" @click="getOutsourceCVOfApplicant">Get Outsource CV Text</button>
          <textarea v-if="rawText" style="display: block; width: 100%;" cols="30" rows="10" placeholder="..." :value="rawText"></textarea>
        </div>
      </div>
      <applicant-cv-pdf v-if="show_pdf" :payload="applicant_data"></applicant-cv-pdf>
    </div>
  </div>
</template>
<script>
import moment from 'moment/moment.js'
import { mapMutations } from 'vuex'
import AttributeDisplay from '@/components/AttributeDisplay'
import AlertButton from '@/components/AlertButton'
import TextsHelper from '@/custom/classes/texts_helper.js'
import TimeHelper from '@/custom/classes/time_helper.js'
import SkillsHelper from '@/custom/classes/skills_helper.js'
import SkillsForm from '@/components/SkillsForm.vue'
import QuestionsHelper from '@/custom/classes/questions_helper.js'
import GhanaFlag from '@/components/GhanaFlag.vue'
import InternalNotes from '@/components/InternalNotes.vue'
import ApplicantCvPdf from '@/components/ApplicantCvPdf.vue'
import ResourceTextEditor from '@/components/ResourceTextEditor.vue'
import QuestionEditor from '@/components/QuestionEditor.vue'
import StartVetting from '@/components/applicants/StartVetting.vue'
import LastWorkingPlaces from '@/components/LastWorkingPlaces.vue'
import ApplicantEducations from '@/components/ApplicantEducations.vue'
import ResourceLanguages from '@/components/ResourceLanguages.vue'
import LocationEditor from '@/components/LocationEditor.vue'
import IsWatch from '@/components/IsWatch.vue'
import IsStar from '@/components/IsStar.vue'
import CompanySuitcase from '@/components/CompanySuitcase'
import IsFreeze from '@/components/IsFreeze.vue'
import DateTime from '@/components/DateTime.vue'
import MessageForm from '@/components/MessageForm.vue'
import FreeSubmission from '@/components/entities/applicant/FreeSubmission'
import ApplicantJobTitles from '@/components/entities/applicant/JobTitles'
import Abstract from '@/components/entities/applicant/Abstract'
import IsDiscrete from '@/components/entities/applicant/IsDiscrete'

export default {
  name: 'applicant-info',
  props: ['payload'],
  data () {
    return {
      texts_helper: new TextsHelper(),
      time_helper: new TimeHelper(),
      skills_helper: new SkillsHelper(),
      questions_helper: new QuestionsHelper(),
      applicant_data: undefined,
      applicant_name: this.payload.data.first_name + ' ' + this.payload.data.last_name,
      tags: this.payload.data.tags,
      referral_link: undefined,
      rawText: '',
      questions: [],
      history_companies: [],
      educations: [],
      languages: [],
      location: {},
      free_submission: null,
      free_submission_approved_at: null,
      texts: {},
      certificationDateOptions: [],
      skills_by_category: {},
      freezed_until: null,
      show_download_cv: false,
      show_pdf: this.payload.modal_open_action == 'click' || this.payload.modal_open_action == undefined,
      is_discrete_question: undefined,
      job_title: undefined,
      approve_email_question: undefined,
      proactive_promotion_question: undefined,
      skip_seniority_filter_question: undefined,
      seniority: undefined
    }
  },
  created () {
    this.$network_utils.getApplicant({ id: this.payload.data.resource_id }).then(response => {
      this.applicant_data = response
      this.freezed_until = response.freezed_until
      this.free_submission = response.free_submission || null
      this.free_submission_approved_at = response.free_submission_approved_at || null
      this.is_discrete_question = response.is_discrete
      this.init()
    })
  },
  computed: {
    seniorityYears () {
      return moment().diff(this.applicant_data.certification_date, 'years')
    },
    isVetted () {
      return ['vetted', 'completed'].includes(this.applicant_data.applicant_status)
    }
  },
  methods: {
    certificationDateUpdate (value) {
      const date = moment(value.split('/').reduce((prev, curr) => curr + '-' + prev, '1')).format('YYYY-MM-DD')
      this.applicant_data.certification_date = date
    },
    init () {
      this.getQuestions()
      this.getSkills()
      this.getTexts()
      this.getHistoryCompanies()
      this.getEducations()
      this.getLocation()
      this.getLanguages()
      this.getReferralLink()
    },
    createElevenMonthAlert () {
      this.$network_utils.postAlert({
        designator: 'missions',
        content: 'ליצור קשר עוד 11 חודשים',
        status: 'active',
        priority: 90,
        resource_type: 'Applicant',
        resource_id: this.payload.resource_id,
        timing: this.$moment().add(11, 'months')
      }).then(() => {
        this.$utils.emit('show_toast', { text: 'נוצר בהצלחה' })
      })
    },
    openWhatsappModal () {
      this.create({
        designator: 'applicant-whatsapp-modal',
        component_name: 'ModalWhatsapp',
        modal_title: this.applicant_name + ' - מועמד',
        modal_width: 500,
        is_center_modal: true,
        props: {
          applicant: this.payload.data
        }
      })
    },
    sendFreeText () {
      this.create({
        designator: 'applicant-whatsapp-modal',
        component_name: 'ModalWhatsappMessager',
        modal_title: this.applicant_name + ' - מועמד',
        modal_width: 700,
        is_center_modal: true,
        props: {
          applicant: this.payload.data
        }
      })
    },
    pickDate (date) {
      this.freezed_until = date
      this.$network_utils.updateApplicant({ applicant_id: this.applicant_data.resource_id, freezed_until: date }).then(() => {
        this.$utils.emit('show_toast', { text: 'תאריך הקפאה עודכן' })
      })
    },
    applicantAnswered () {
      this.$network_utils.postStat({
        title: 'Applicant answered phone',
        designator: 'applicant_answered_phone',
        status: 'active',
        owner: this.$utils.getOwner().name,
        priority: 5,
        resource_type: 'Applicant',
        resource_id: this.applicant_data.resource_id
      }).then(() => this.$utils.emit('show_toast', { text: 'success' }))
    },
    getReferralLink () {
      this.$network_utils.getReferralLink({ current_type: 'Applicant', current_resource_id: this.applicant_data.resource_id }).then((response) => {
        if (response == undefined || response.referral_link == undefined) {
          return
        }
        this.referral_link = response.referral_link
      })
    },
    copyAffiliateText () {
      let app_name = this.$settings.get({ path: 'app_name' })
      let full_name = this.applicant_data.first_name + ' ' + this.applicant_data.last_name
      let referral_link = this.referral_link + '&invited_by=' + encodeURIComponent(full_name)
      let discrete_emoji = this.$settings.get({ path: 'discrete_emoji' })
      let text = `לא רק לי מגיע להגיע למשרת החלומות שלי! הצטרפו אל ${app_name} דרך הקישור בתחתית ההודעה, ותוכלו לסלול לעצמכם את המשך הקריירה בעולם ${this.$settings.get({ path: 'field' })} ${discrete_emoji} אפשר גם בדיסקרטיות ${discrete_emoji}\n\n${referral_link}`
      this.$utils.copyToClipboard(text)
    },
    submitTags () {
      this.$network_utils.updateUser({ user_id: this.payload.data.id, tags: this.tags }).then(() => {
        this.$utils.emit('show_toast', { text: 'tags עודכן' })
      })
    },
    async getRawTextOfApplicant () {
      const response = await this.$network_utils.getApplicantRawText({ id: this.applicant_data.resource_id })
      this.rawText = response.data
    },
    async getOutsourceCVOfApplicant () {
      const response = await this.$network_utils.getResourceTexts({ current_type: 'Applicant', current_resource_id: this.applicant_data.resource_id })
      this.rawText = (this.texts_helper.getTextByDesignator(response, 'outsource_cv_text') || {}).content
    },
    downloadCv () {
      this.$network_utils.downloadCv({ current_resource_id: this.applicant_data.resource_id, current_type: 'Applicant' })
    },
    getQuestions () {
      let designators = 'seniority,only_peek,is_discrete,certification_date,interview_score,work_scope,approve_email,accept_push,proactive_promotion,is_senior,job_title,office_size,stargate_supplier,skip_educations_filter,skip_seniority_filter'
      this.$network_utils
        .getResourceQuestions({
          current_type: 'Applicant',
          current_resource_id: this.applicant_data.resource_id,
          designators: designators
        })
        .then(response => {
          let designators_black_list = ['seniority', 'job_title', 'stargate_supplier', 'certification_date', 'is_discrete', 'skip_educations_filter', 'skip_seniority_filter', 'approve_email', 'proactive_promotion']
          this.questions = response.filter(question => !designators_black_list.includes(question.designator))
          const certification_date = response.find(question => question.designator == 'certification_date') || { options: [] }
          this.certificationDateOptions = certification_date.options.map(options => ({ label: options.text, value: this.prettifyDate(options.text) })).sort((a, b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0))
          let stargate_supplier_question = this.questions_helper.getQuestionByDesignator(response, 'stargate_supplier')
          let stargate_supplier_answer_text = this.questions_helper.getSingleAnswerText(stargate_supplier_question)
          this.show_download_cv = stargate_supplier_answer_text.length > 0
          this.job_title = this.questions_helper.getQuestionByDesignator(response, 'job_title')
          this.seniority = this.questions_helper.getQuestionByDesignator(response, 'seniority')
          this.skip_seniority_filter_question = this.questions_helper.getQuestionByDesignator(response, 'skip_seniority_filter')
          this.approve_email_question = this.questions_helper.getQuestionByDesignator(response, 'approve_email')
          this.proactive_promotion_question = this.questions_helper.getQuestionByDesignator(response, 'proactive_promotion')
        })
    },
    prettifyDate (date) {
      const a = date.split('/')
      return `${a[1]}-${a[0].padStart(2, '0')}-01`
    },
    getHistoryCompanies () {
      this.$network_utils
        .getApplicantHistoryCompanies({
          current_type: 'Applicant',
          current_applicant_id: this.applicant_data.resource_id
        })
        .then(response => {
          if (response.length == 0) {
            return
          }
          this.history_companies = response
        })
    },
    getEducations () {
      this.$network_utils.getApplicantEducations({ current_applicant_id: this.applicant_data.resource_id }).then(response => {
        this.educations = response
      })
    },
    getLocation () {
      this.$network_utils.getResourceLocations({ current_type: 'Applicant', current_resource_id: this.applicant_data.resource_id }).then(response => {
        this.location = response[0]
      })
    },
    getLanguages () {
      this.$network_utils.getApplicantLanguages({ current_applicant_id: this.applicant_data.resource_id }).then(response => {
        this.languages = response
      })
    },
    getSkills () {
      this.$network_utils
        .getApplicantSkills({
          current_applicant_id: this.applicant_data.resource_id
        })
        .then(response => {
          this.skills_by_category = this.skills_helper.getSkillsByCategory(
            response
          )
        })
    },
    getTexts () {
      this.$network_utils.getResourceTexts({
        current_type: 'Applicant',
        current_resource_id: this.applicant_data.resource_id
      }).then(response => {
        this.setTexts(response)
      })
    },
    setTexts (server_response) {
      let temp_texts = {}
      for (let i = 0; i < server_response.length; i++) {
        let text = server_response[i]
        let designator = text.designator
        text.content = this.texts_helper.getContent(text)
        temp_texts[designator] = text
      }
      this.texts = temp_texts
    },
    openProfileModal () {
      this.create({
        designator: 'applicant-profile-modal',
        component_name: 'ApplicantProfilePdf',
        applicant_id: this.payload.data.resource_id,
        modal_title: this.applicant_name + ' - פרופיל מועמד',
        modal_width: 1000,
        is_center_modal: true
      })
    },
    openFilesModal () {
      this.create({ designator: 'applicant-files-modal', component_name: 'Files', applicant_data: this.payload.data, applicant_id: this.applicant_data.resource_id, modal_title: this.applicant_name + ' Files' })
    },
    openSkillsModal () {
      this.create({ designator: 'applicant-skill-form-modal', component_name: 'ApplicantSkillsForm', data: this.payload.data, modal_title: this.applicant_name + ' Skills', modal_width: 1300, is_center_modal: true })
    },
    openNewVettingModal () {
      let modal_title = this.applicant_data.first_name + ' ' + this.applicant_data.last_name + ' Vetting'
      this.create({ designator: 'vetting-modal', component_name: 'ModalVettingForm', applicant_id: this.applicant_data.resource_id, modal_title: modal_title, ignore_escape_button: true, modal_width: 2400, is_center_modal: true })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    GhanaFlag,
    InternalNotes,
    ApplicantCvPdf,
    SkillsForm,
    ResourceTextEditor,
    QuestionEditor,
    StartVetting,
    ApplicantJobTitles,
    LastWorkingPlaces,
    ApplicantEducations,
    ResourceLanguages,
    IsDiscrete,
    IsStar,
    IsWatch,
    CompanySuitcase,
    MessageForm,
    AlertButton,
    AttributeDisplay,
    LocationEditor,
    DateTime,
    IsFreeze,
    Abstract,
    FreeSubmission
  }
}
</script>
<style>
  .applicant_info_container{
    width: 100%;
  }
  .applicant_info_container_with_pdf{
    padding-left: 20px;
    margin-left: 20px;
    border-left: 1px solid rgba(0, 0, 0, 0.1);
  }
  .image-style {
    width: 30px;
  }
</style>
